import HttpService from './baseHttp'

// 入库计划单分页查询
export const HttpInboundBillClientList = (data) => HttpService.get('/api/v2/Inbound/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 入库计划单取消
export const HttpCancelInboundBill = (data) => HttpService.post('/api/v2/Inbound/cancel', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpRemarkInboundBill = (data) => HttpService.post('/api/v2/Inbound/remark', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 完成
export const HttpComplateInboundBill = (data) => HttpService.post('/api/v2/Inbound/complate', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 审核
export const HttpCheckInboundBill = (data) => HttpService.post('/api/v2/Inbound/check', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 撤销审核
export const HttpRevokeAudit = (data) => HttpService.post('/api/v2/Inbound/revokeAudit', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 复制单据
export const HttpCopyInboundPlanOrder = (data) => HttpService.post('/api/v2/Inbound/copyInboundPlanOrder', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 换仓1
export const HttpChangeWarehouse = (data) => HttpService.post('/api/v2/Inbound/changeWarehouse', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 换仓2
export const HttpChangeSimpleWarehouse = (data) => HttpService.post('/api/v2/Inbound/simpleChangeWarehouse', data, { baseURL: process.env.VUE_APP_APIURL_FBB  });


// 导出
export const HttpExportInboundBill = (data, config) => HttpService.get('/api/v2/Inbound/batchExport', { params: data, ...config, baseURL: process.env.VUE_APP_APIURL_FBB });
// 到仓确认
export const HttpConfirmAtWarehouse = (data) => HttpService.post('/api/v2/Inbound/confirmAtWarehouse', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 到港确认
export const HttpConfirmAPost = (data) => HttpService.post('/api/v2/Inbound/confirmAtPost', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 确认发货
export const HttpConfirmShipment = (data) => HttpService.post('/api/v2/Inbound/confirmShipment', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 删除附件
export const HttpDelAttachments = (data) => HttpService.post('/api/v2/Inbound/deleteAttachments', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 上传附件
export const HttpUploadAttachments = (data, config) => HttpService.post('/api/v2/Inbound/attachmentUpload', data, { ...config, baseURL: process.env.VUE_APP_APIURL_FBB });
// 入库计划单导入产品明细
export const HttpImportProducts = (data, config) => HttpService.post('/api/v2/Inbound/importProducts', data, { ...config, baseURL: process.env.VUE_APP_APIURL_FBB });
// 重推仓库
export const HttpPushWareHouse = (data, ) => HttpService.post('/api/v2/Inbound/pushWarehouse', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 产品查询接口
export const HttpProductList = (data) => HttpService.get('/api/v2/product/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpProductInfo = (data) => HttpService.get('/api/v2/product/getProductInfo', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 计划发运信息
export const HttpInboundBillItem = (data) => HttpService.get('/api/v2/Inbound/itemDetail', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 提交
export const HttpSubmitInboundBill = (data) => HttpService.post('/api/v2/Inbound/submit', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 批量提交
export const HttpBatchSubmitInboundBill = (data) => HttpService.post('/api/v2/Inbound/batchSubmit', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 异常重处理
export const HttpReprocessError = (data) => HttpService.post('/api/v2/Inbound/errorReprocess', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 忽略异常
export const HttpIgnoreInboundError = (data) => HttpService.post('/api/v2/Inbound/ignoreError', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 创建提交
export const HttpSaveAndSubmitInboundBill = (data) => HttpService.post('/api/v2/Inbound/saveAndSubmit', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpUpdateAndSubmitInboundBill = (data) => HttpService.post('/api/v2/Inbound/updateAndSubmit', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });

// 创建
export const HttpAddInboundBill = (data) => HttpService.post('/api/v2/Inbound/create', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 更新
export const HttpUpdateInboundBill = (data) => HttpService.post('/api/v2/Inbound/update', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 详情
export const HttpInboundBill = (data) => HttpService.get('/api/v2/Inbound/detail', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 分页查询装箱
export const HttptPackageCodeList = (data) => HttpService.get('/api/v2/InboundBox/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 装箱界面SKU下拉列表
export const HttpSkuList = (data) => HttpService.get('/api/v2/Inbound/packageSkuList', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 装箱信息
export const HttpPackageList = (data) => HttpService.get('/api/v2/Inbound/packageDetail', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 导出装箱
export const HttpExportPackage = (data, config) => HttpService.get('/api/v2/InboundBox/exportPackages', { params: data, ...config, baseURL: process.env.VUE_APP_APIURL_FBB });
// 逐个装箱
export const HttpAddPackage = (data) => HttpService.post('/api/v2/InboundBox/packageOneByOne', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 导入装箱
export const HttpImportPackage = (data, config) => HttpService.post('/api/v2/InboundBox/importPackages', data, { ...config, baseURL: process.env.VUE_APP_APIURL_FBB });
// 一键装箱
export const HttpOnceBoxingPackage = (data) => HttpService.post('/api/v2/InboundBox/oneButtonPackages', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 导入FBA装箱
export const HttpImportFbaPackage = (data, config) => HttpService.post('/api/v2/InboundBox/importFbaPackages', data, { ...config, baseURL: process.env.VUE_APP_APIURL_FBB });
// 删除装箱
export const HttpDelPackage = (data) => HttpService.post('/api/v2/InboundBox/deletePackages', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 清空装箱
export const HttpClearPackage = (data) => HttpService.post('/api/v2/InboundBox/deleteAllPackages', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 生成箱标
export const HttpCreatePackageLabel = (data) => HttpService.post('/api/v2/InboundBox/boxLabelGenerate', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 批量生成箱标
export const HttpCreateBatchPackageLabel = (data) => HttpService.post('/api/v2/InboundBox/batchBoxLabelGenerate', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 下载箱标
export const HttpDownloadPackageLabel = (data, config) => HttpService.get('/api/v2/Inbound/downloadBoxlabel', { params: data, ...config, baseURL: process.env.VUE_APP_APIURL_FBB });
//附件重推
export const HttpRetryAttach = (data) => HttpService.post('/api/v2/Inbound/repushAttachment', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

//  入库单api
// 入库执行单分页查询
export const HttpInboundOrderList = (data) => HttpService.get('/api/v2/InboundOrder/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//入库计划执行单明细分页
export const HttpInboundOrderPage = (data) => HttpService.get('/api/v2/InboundOrderItem/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 创建
export const HttpAddInboundOrder = (data) => HttpService.post('/api/v2/InboundOrder/create', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 按箱码添加入库执行单明细
export const HttpAddInboundItemByBox = (data) => HttpService.post('/api/v2/InboundOrder/addItemByBoxbarcode', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 按SKU添加入库执行单明细
export const HttpAddInboundItemBySku = (data) => HttpService.post('/api/v2/InboundOrder/addItemBySku', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 一键接收
export const HttpReceiveInboundItems = (data) => HttpService.post('/api/v2/InboundOrder/oneButtonReceive', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 导入接收明细
export const HttpImportInboundItems = (data, config) => HttpService.post('/api/v2/InboundOrder/importReceive', data, { ...config, baseURL: process.env.VUE_APP_APIURL_FBB });
// 删除接收明细
export const HttpdelInboundItems = (data) => HttpService.post('/api/v2/InboundOrder/deleteReceiveItems', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 清除接收明细
export const HttpClearInboundItems = (data) => HttpService.post('/api/v2/InboundOrder/deleteAllReceiveItems', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 详情
export const HttpInboundOrder = (data) => HttpService.get('/api/v2/InboundOrder/detail', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 更新入库执行单
export const HttpUpdateInboundOrder = (data) => HttpService.post('/api/v2/InboundOrder/save', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 确认
export const HttpConfirmInboundOrder = (data) => HttpService.post('/api/v2/InboundOrder/confirm', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 取消
export const HttpCancelInboundOrder = (data) => HttpService.post('/api/v2/InboundOrder/cancel', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 批量导出
export const HttpExportInboundOrder = (data, config) => HttpService.get('/api/v2/InboundOrder/batchExport', { ...config, params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 日志
export const HttpInboundOrderLogList = (data) => HttpService.get('/api/v2/OrderLog/findByFilters', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 新增查看物流历史的弹框
export const HttpInboundHeadLogistics = (data) => HttpService.post('/api/v2/LogisticsHead/getShipmentDetailBySubLgNo', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 获取物流状态流程节点
export const HttpInboundSubscribe = (data) => HttpService.post('/api/v2/inboundPlanSubscribe/getByOrderNo', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 新增采购导入

//
export const HttpSaveInboundPoItems = (data) => HttpService.post('/api/v2/Inbound/updateInboundPoItems', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });


// 判断list附件
export const HttpIsPackList = (data) => HttpService.post('/api/v2/Inbound/checkPackingList', data, { baseURL: process.env.VUE_APP_APIURL_FBB });



// 上传附件
export const HttpUploadCompleteFile = (data, config) => HttpService.post('/api/v1/BizAttach/uploadFile', data, { ...config, baseURL: process.env.VUE_APP_APIURL_UC });


// 查询erpsku获取对应的英文名称
export const HttpGetSKUEnName = (data) => HttpService.get('/api/v1/Product/findAllByProductIds', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 修改发运信息
export const HttpChangeShipment = (data) => HttpService.post('/api/v2/Inbound/updateShipment', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });


// 根据入库单号查询预约单
export const HttpGetAppointList = (data) => HttpService.get('/api/v2/ReserveInbound/getByInboundNo', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 入库计划计算总体积和重量
// export const HttpGetcalculateWeightAndVolume = (data) => HttpService.get('/api/v2/Inbound/calculateWeightAndVolume', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpGetcalculateWeightAndVolume = (data) => HttpService.post('/api/v2/Inbound/calculateWeightAndVolume', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });


// 批量下载，生成箱标
export const HttpDownCarton = (data, config) => HttpService.get('/api/v2/Inbound/batchDownLoadBoxLabel', { params: data, ...config, baseURL: process.env.VUE_APP_APIURL_FBB });
// export const HttpChangeWarehouse = (data) => HttpService.post('/api/v2/Inbound/changeWarehouse', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 标签数量，客户+管理

export const HttpGetInbopundSpan = (data) => HttpService.post('/api/v2/Inbound/getCountByStatus', {isManage:false,...data}, { baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpGetInbopundMangeSpan = (data) => HttpService.post('/api/v2/Inbound/getCountByStatus', {isManage:true,...data}, { baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpCheckCapacity = (data) => HttpService.get('/api/v2/Inbound/checkCapacity', { params: data, baseURL:  process.env.VUE_APP_APIURL_FBB  });

//入库执行单批量确认
export const HttpBatchConfirmInboundOrder = (data) => HttpService.post('/api/v2/InboundOrder/batchConfirm', data, { baseURL: process.env.VUE_APP_APIURL_FBB });

//查询库容
export const HttpGetCapacity = (data) => HttpService.post('/api/v2/Inbound/showCapacity', data, { baseURL: process.env.VUE_APP_APIURL_FBB});

export const HttpBossProductList = (data) => HttpService.get('/api/v1/Product/findByPage', { params: data, baseURL:process.env.VUE_APP_APIURL_BOSS });

export const HttpInboundWinitReceipt = (data) => HttpService.post('/api/v2/Inbound/inboundWinitReceipt',data, {baseURL:process.env.VUE_APP_APIURL_FBB });

//无来源入库
export const HttpUnsourcedInboundList = (data) => HttpService.get('/api/v2/UnsourcedInbound/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});

export const HttpUnsourcedInbound = (data) => HttpService.post('/api/v2/UnsourcedInbound/detail', data, { baseURL: process.env.VUE_APP_APIURL_FBB});

export const HttpExportUnsourcedInbound = (data, config) => HttpService.get('/api/v2/UnsourcedInbound/batchExport', { ...config, params: data, baseURL: process.env.VUE_APP_APIURL_FBB});
//上传发票
export const HttpUploadBill = (data) => HttpService.post('/api/v2/Inbound/uploadBill', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//更新预计到仓时间
export const HttpUpdateInboundDate = (data) => HttpService.post('/api/v2/Inbound/updateInboundDate', data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 采购单明细
export const HttpPurchaseList = (data) => HttpService.get('/api/v2/Inbound/getPoItems', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});

// 获取区域
export const HttpGetOrgAreaOption = (data) => HttpService.post('/api/v2/Inbound/getArea', data);
// 获取未启用区域分仓仓库
export const HttpGetNoAreaWarehouse = (data) => HttpService.get('/api/v2/Inbound/findByAreaAndWarehouse', { params: data });
// 根据区域获取仓库
export const HttpGetWarehouseByAreaId = (data) => HttpService.get('/api/v2/organizationWarehouse/findByAreaId', { params: data });
// 根据入库计划单自动计算
export const HttpAutoCalculateWarehouse = (data) => HttpService.post('/api/v2/Inbound/checkWarehouse', data);
// 获取区域列表
export const HttpGetAreaList = (data) => HttpService.get('/api/v2/areaManage/findAll', { params: data });
//修改日期
export const HttpModifyDateInbound = (data) => HttpService.post('/api/v2/Inbound/updateExpectAndPredictionDate',data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });


// 获取船下拉
export const HttpGetBoatList = (data) => HttpService.get('/api/v2/boatCompanyInfo/findAll', { params: data });

